import { useInjection } from "@linkfluence/core/di";
import {
  UserRepo,
  UserRepositoryUID,
} from "@linkfluence/core/user/repositories/UserRepo";
import { User } from "@linkfluence/models/user";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useUploadUserPictures(user: User) {
  const repository = useInjection<UserRepo>(UserRepositoryUID);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (data: { files: File[] }) => {
      return repository.uploadUserPictures(user.id, data.files);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["/user/avatars"]);
      },
    }
  );
  return async (files: File[]) => {
    await mutateAsync({ files });
  };
}
